import React, { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import api from "@/lib/api";

export const JobSalaryInsight = ({ slug }) => {
    const [insight, setInsight] = useState(null);
    useEffect(() => {
        let cancelled = false;
        setInsight(null);
        api.get(`/public/jobs/by-slug/${encodeURIComponent(slug)}/salary-insights`)
            .then(({ data }) => { if (!cancelled) setInsight(data); })
            .catch(() => { /* An optional estimate must never block a job application. */ });
        return () => { cancelled = true; };
    }, [slug]);
    if (!insight?.median) return null;
    const annual = insight.period === "YEAR";
    const amount = new Intl.NumberFormat("en-US", {
        style: "currency", currency: insight.currency,
        notation: annual ? "compact" : "standard", maximumFractionDigits: annual ? 1 : 2,
    }).format(insight.median).replace("K", "k");
    const period = { YEAR: "year", MONTH: "month", WEEK: "week", DAY: "day", HOUR: "hour" }[insight.period];
    return (
        <div className="mt-4 border-l-2 border-emerald-500 pl-3 text-sm" data-testid="public-job-salary-insight">
            <p className="flex items-start gap-2 text-foreground" data-testid="public-job-salary-median">
                <TrendingUp size={15} className="mt-0.5 shrink-0 text-emerald-600" />
                <span><strong>{amount}/{period}</strong> median for similar roles in {insight.location}</span>
            </p>
            <p className="mt-1 text-xs text-muted-foreground" data-testid="public-job-salary-source">
                Based on {insight.sample} other Simonara postings · median of advertised range midpoints, not this employer’s offer.
            </p>
        </div>
    );
};